import React from "react";
import "../css/styles.css";

const Loading = ({title, subtitle}) => (
    <div className="loading" style={{height: '500px', display: 'flex', alignItems: 'center', justifyContent: 'center',   flexDirection: 'column', gap: '16px'}}>
        {title &&<p className="loader__title">{title}</p>}
        <div className="loader__spinner"></div>
        {subtitle && <p className="loader__subtitle">{subtitle}</p>}
    </div>
);

export default Loading;
